<template>
    <dash
        icon="fa fa-comments"
        titulo="RESPOSTAS ÁS PESQUISAS"
        @click.native="
            $router.push({
                name: 'Pesquisas_Respostas'
            })
        "
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
